import * as React from "react";

const SvgPhoneoutgoing = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M15.649 3.486h4.865M20.514 3.486v4.865M20.514 3.486l-5.838 5.838M4.946 3.486A1.946 1.946 0 0 0 3 5.432v.973C3 14.465 9.534 21 17.595 21h.973a1.946 1.946 0 0 0 1.946-1.946v-3.19a.973.973 0 0 0-.666-.924l-4.372-1.457a.973.973 0 0 0-1.178.488L13.2 16.167A10.743 10.743 0 0 1 7.833 10.8l2.196-1.098a.973.973 0 0 0 .488-1.178L9.06 4.152a.973.973 0 0 0-.923-.666H4.946Z" />
    </g>
  </svg>
);

export default SvgPhoneoutgoing;
